import {event} from '../modules/event';

var mainLogo = function(wrapper){
    var logo = wrapper.firstChild.nodeType == 1 ? wrapper.firstChild : wrapper.firstChild.nextSibling;
    logo.innerHTML = logo.firstChild.nodeValue.replace(/./g, "<span class=\"mainLogo_letter\">$&</span>");

    if (document.readyState === "complete") {
        logo.className = logo.className + ' g-active';
    } else {
        event.add(window, 'load', function(){
            logo.className = logo.className + ' g-active';
        });
    }
}

export {mainLogo};










